import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  fullScreen: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    overflow: 'auto',
    zIndex: '9000',
    minWidth: '100vw',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgb(0,0,0)',
  },
  containerSize: {
    width: '100%',
    height: '100%',
  },
}));

const FullScreenComponent = ({
  children,
  toggleFullScreen,
  requestFileEffect,
  isFullScreen,
}) => {
  const classes = useStyles();
  return (
    <div className={isFullScreen ? classes.fullScreen : classes.containerSize}>
      {children}
    </div>
  );
};

export default FullScreenComponent;
